<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-10">{{ title }}</h3>

		<dl class="flex flex-col gap-8">
			<div v-for="(item, index) in data" :key="index" class="relative pl-4">
				<span class="absolute -left-1 -top-6 text-[80px] font-black text-gray-200 leading-none select-none z-0">
					{{ index + 1 }}
				</span>

				<dt class="relative z-10 font-bold uppercase text-gray-800 mb-1 tracking-wide">
					{{ item.question }}
				</dt>

				<dd class="relative z-10 text-gray-600 font-medium">
					{{ item.answer }}
				</dd>
			</div>
		</dl>
	</DjBox>
</template>

<script lang="ts">
import DjBox from "./DjBox.vue";
import { defineComponent, PropType } from "vue";

type QuickQuestionData = {
	question: string;
	answer: string;
};

export default defineComponent({
	name: "DjBoxQuickQuestions",
	components: {
		DjBox,
	},
	props: {
		title: {
			type: String,
			default: "",
			required: true,
		},
		data: {
			type: Array as PropType<QuickQuestionData[]>,
			default: () => [],
		},
	},
});
</script>
